import type { CodeSessionEvent } from '@/lib/code-sessions/types';
import type { FormInfo } from '@opencode/client/promise';

import type { CodeFormSubmission } from './types';

export function pendingCodeSessionForms(
  snapshotForms: readonly FormInfo[] | null | undefined,
  events: readonly CodeSessionEvent[],
  answers: Readonly<Record<string, CodeFormSubmission>>,
): FormInfo[] {
  // Pending forms: transcript snapshot, plus live form.created additions,
  // minus forms answered/cancelled via volatile events.
  const forms = new Map<string, FormInfo>();
  for (const form of snapshotForms ?? []) {
    forms.set(form.id, form);
  }
  for (const event of events) {
    if (event.kind !== 'agent') {
      continue;
    }
    const eventData =
      typeof event.data === 'object' && event.data !== null
        ? (event.data as Record<string, unknown>)
        : {};
    if (event.type === 'form.created') {
      const form = eventData.form as FormInfo | undefined;
      if (form !== undefined && typeof form.id === 'string') {
        forms.set(form.id, form);
      }
    } else if (event.type === 'form.replied' || event.type === 'form.cancelled') {
      const id = eventData.id ?? eventData.formID;
      if (typeof id === 'string') {
        forms.delete(id);
      }
    }
  }
  return [...forms.values()].filter((form) => answers[form.id]?.status !== 'submitted');
}
